import PathwayDegreeCourseModel from './pathway_degree_course.model';
import PathwayModel from './pathways.model';
import CourseOfferingsModel from './course_offerings.model.js';

export default class PathwayCourseList {
  constructor() {
    this._pathwayCourses = [];
  }

  set pathwayCourses(pathwayCourseList) {
    this._pathwayCourses = [];

    if (pathwayCourseList instanceof Object) {
      this._pathwayCourses.push(new PathwayModel(pathwayCourseList));

      // Handle two different response structures:
      // 1. Enrolled state: pathwayCourseList.courses.required/recommended are arrays
      // 2. Non-enrolled state: pathwayCourseList.pathwayCourses.required/recommended are objects with prefix keys

      const coursesData = pathwayCourseList.courses || pathwayCourseList.pathwayCourses;

      if (coursesData) {
        const { required = [], recommended = [] } = coursesData;

        // Process required courses
        // Handle both array format (enrolled) and object format (non-enrolled)
        const requiredArray = Array.isArray(required) ? required : Object.values(required).flat();
        requiredArray.forEach((course) => {
          const pathwayCourse = new PathwayDegreeCourseModel({
            ...course,
            pathwayRequirement: 'required'
          });
          pathwayCourse._courseOfferingData = (course.courseOfferings || course.availableOfferings || []).map(
            (courseOffering) => new CourseOfferingsModel(courseOffering)
          );
          this._pathwayCourses[0]._pathwayCourses.push(pathwayCourse);
        });

        // Process recommended courses
        const recommendedArray = Array.isArray(recommended) ? recommended : Object.values(recommended).flat();
        recommendedArray.forEach((course) => {
          const pathwayCourse = new PathwayDegreeCourseModel({
            ...course,
            pathwayRequirement: 'recommended'
          });
          pathwayCourse._courseOfferingData = (course.courseOfferings || course.availableOfferings || []).map(
            (courseOffering) => new CourseOfferingsModel(courseOffering)
          );
          this._pathwayCourses[0]._pathwayCourses.push(pathwayCourse);
        });
      }
    }
  }

  get pathwayCourses() {
    return this._pathwayCourses;
  }

  get pathwayCourseListPageData() {
    return {
      pathwayCourses: this.pathwayCourses[0]
    };
  }
}
